import { WorkflowEvent } from '@amzn/awscat-pattern-library-service-model';
import { useLoadedDocumentHandle } from './useLoadedDocumentHandle';

/** Subscribes to the {@link ContentEditorService} and returns workflow events for the current version. */
export function useContentWorkflowEvents(): readonly WorkflowEvent[] | undefined {
  return useLoadedDocumentHandle()?.events;
}
